// barba.js
barba.init({
    transitions: [
        {
            name: "fade-transition",
            async leave(data) {
                await fadeOut(data.current.container);
            },
            async enter(data) {
                fadeIn(data.next.container);
                await initializePage(data.next.container);
            },
        },
    ],
});

// Fade-out
function fadeOut(element) {
    return new Promise((resolve) => {
        element.style.transition = "opacity .4s cubic-bezier(0.5, 0.5, 0, 1)";
        element.style.opacity = "0";
        setTimeout(() => {
            element.style.display = "none";
            resolve();
        }, 400);
    });
}

// Fade-in
function fadeIn(element) {
    element.style.display = "block";
    element.style.opacity = "0";
    element.offsetHeight;
    element.style.transition = "opacity .4s cubic-bezier(0.5, 0.5, 0, 1)";
    element.style.opacity = "1";
}

document.addEventListener("DOMContentLoaded", () => {
    initializePage(document.body);
});

// Fade animate
$(document).ready(function () {
    const images = document.querySelectorAll(".fade-in-out");

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const { isIntersecting, target } = entry;

                if (isIntersecting && !target.classList.contains("visible")) {
                    const delay = target.dataset.delay || 0;

                    setTimeout(() => {
                        target.classList.add("visible");
                    }, delay);
                }
            });
        },
        { threshold: 0.05 },
    );

    images.forEach((image) => observer.observe(image));
});

// Text animate
$(function () {
    const $win = $(window);

    const startColor = { r: 231, g: 231, b: 231 }; // #e7e7e7
    const endColor = { r: 20, g: 17, b: 15 }; // #14110f

    // Textleri span içine al (1 kere)
    $(".fade-to-dark").each(function () {
        const text = this.textContent.trim();
        if (!text) return;

        this.innerHTML = text
            .split(/\s+/)
            .map((word) => `<span>${word}</span>`)
            .join(" ");
    });

    function animateScrollReveal() {
        const scrollTop = $win.scrollTop();
        const windowHeight = $win.height();

        $(".reveal-section").each(function () {
            const sectionTop = $(this).offset().top;

            const start = sectionTop - windowHeight;
            const end = sectionTop;

            let progress = (scrollTop - start) / (end - start);
            progress = Math.min(Math.max(progress, 0), 1);

            const words = this.querySelectorAll(".fade-to-dark span");
            const totalWords = words.length;
            if (!totalWords) return;

            for (let i = 0; i < totalWords; i++) {
                const wordStart = i / totalWords;
                const wordEnd = (i + 1) / totalWords;

                let wordProgress =
                    (progress - wordStart) / (wordEnd - wordStart);

                wordProgress = Math.min(Math.max(wordProgress, 0), 1);

                const r = Math.round(
                    startColor.r + (endColor.r - startColor.r) * wordProgress,
                );
                const g = Math.round(
                    startColor.g + (endColor.g - startColor.g) * wordProgress,
                );
                const b = Math.round(
                    startColor.b + (endColor.b - startColor.b) * wordProgress,
                );

                words[i].style.color = `rgb(${r},${g},${b})`;
            }
        });
    }

    $win.on("scroll", animateScrollReveal);
    animateScrollReveal();
});
